import _ from 'lodash'

const stateIconBg = {
    methods: {
        // 업체 아이콘 처리
        stateIconBg (soc, c_state, brk) {
            let stateIconStr = `background-image: url('/img/state/`;
            
            if (0 <= soc && soc <= 20) {
                stateIconStr += `row-`;
            } else if (20 < soc && soc <= 60) {
                stateIconStr += `middle-`;
            } else if (60 < soc && soc <= 100) {
                stateIconStr += `high-`;
            }
            
            // hex값 구분 필요 
            if (c_state == "01" || c_state == "00") {
                stateIconStr += `discharging-`;
            } else {
                stateIconStr += `charging-`;
            } 

            switch (brk) {
                case "1" : 
                    stateIconStr += `end.png')`;
                    break; 
                case "0" :
                    stateIconStr += `start.png')`;
                    break; 
            }
            
            return stateIconStr;
        }
    }
}

export default stateIconBg